import { render, staticRenderFns } from "./VesselTypeList.vue?vue&type=template&id=75661b28&scoped=true"
import script from "./VesselTypeList.vue?vue&type=script&lang=js"
export * from "./VesselTypeList.vue?vue&type=script&lang=js"
import style0 from "./VesselTypeList.vue?vue&type=style&index=0&id=75661b28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75661b28",
  null
  
)

export default component.exports